import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import AppNavbar from "../../components/common/AppNavbar";
import Loading from "../../components/common/Loading";

function HomeMasterDetail() {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchDetail() {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/homemasters`
        );
        const json = await res.json();

        const matched = json.find((item) => String(item.id) === String(id));

        if (!matched) {
          throw new Error("Article not found");
        }

        setData(matched);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    }

    fetchDetail();
  }, [id]);

  if (loading) return <Loading />;
  if (error) return <div style={{ padding: "20px" }}>{error}</div>;

  return (
    <>
      <AppNavbar />

      <div className="container" style={{ maxWidth: "900px", padding: "20px" }}>
        <h1 style={{ fontWeight: 700, marginBottom: "15px" }}>
          {data.HM_Title}
        </h1>

        {data.HM_Image && (
          <img
            src={data.HM_Image}
            alt={data.HM_Title}
            style={{
              width: "100%",
              maxHeight: "450px",
              objectFit: "cover",
              marginBottom: "20px",
            }}
          />
        )}

        {data.HM_Lead && (
          <p
            style={{
              fontSize: "18px",
              fontWeight: 500,
              color: "#444",
              marginBottom: "15px",
            }}
          >
            {data.HM_Lead}
          </p>
        )}

        <div
          style={{
            fontSize: "16px",
            lineHeight: "1.8",
            color: "#222",
            whiteSpace: "pre-line",
          }}
        >
          {data.HM_Description}
        </div>
      </div>
    </>
  );
}

export default HomeMasterDetail;
